import React from 'react';

/**
 * Petlings Logo - pixel-art paw print with Minecraft-style blocky depth.
 * Toe beans are rounded squares (pixel blocks), main pad has a heart cutout,
 * and a small leaf accent ties it to the nature/companion theme.
 * 3D effect via darker bottom edges on each block.
 */
export default function PetlingsLogo({ size = 24, color, className = '' }) {
  const fill = color || '#8BC34A';

  // Derive shadow and highlight from base color
  const isCustom = color && color !== '#8BC34A';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Toe beans - rounded pixel blocks with 3D bottom edge */}
      {/* Bean 1 (left) */}
      <rect x="5" y="3" width="6" height="6" rx="1.5" fill={fill} />
      <rect x="5" y="7" width="6" height="2" rx="0.5" fill="black" opacity="0.15" />

      {/* Bean 2 (center-left) */}
      <rect x="13" y="1" width="6" height="6" rx="1.5" fill={fill} />
      <rect x="13" y="5" width="6" height="2" rx="0.5" fill="black" opacity="0.15" />

      {/* Bean 3 (center-right) */}
      <rect x="21" y="3" width="6" height="6" rx="1.5" fill={fill} />
      <rect x="21" y="7" width="6" height="2" rx="0.5" fill="black" opacity="0.15" />

      {/* Main pad - rounded square block */}
      <rect x="4" y="12" width="24" height="16" rx="4" fill={fill} />
      {/* 3D bottom edge */}
      <rect x="4" y="24" width="24" height="4" rx="2" fill="black" opacity="0.12" />
      {/* Highlight top edge */}
      <rect x="6" y="12" width="20" height="2" rx="1" fill="white" opacity="0.2" />

      {/* Heart cutout in pad */}
      <path
        d="M16 19C16 19 12.5 16.5 11 17.5C9.5 18.5 11.5 20.5 16 24C20.5 20.5 22.5 18.5 21 17.5C19.5 16.5 16 19 16 19Z"
        fill="white"
        opacity="0.3"
      />

      {/* Tiny leaf accent (top-right) */}
      {!isCustom && (
        <g transform="translate(25, 0)">
          <path d="M2 6C2 6 0 2 4 0C4 0 6 4 2 6Z" fill="#4CAF50" />
          <path d="M3 5.5L3.5 1" stroke="#388E3C" strokeWidth="0.5" strokeLinecap="round" />
        </g>
      )}
    </svg>
  );
}
